import { useShallow } from 'zustand/react/shallow';
import { useDeviceInfoStore, WEBVIEW_TYPE } from '@/stores/DeviceStore';
export const useCheckWelloApp = () => {
  return useDeviceInfoStore(useShallow(_temp));
};
function _temp(t0) {
  const {
    webviewType,
    isMounted
  } = t0;
  return {
    isChecking: !isMounted,
    isWelloApp: webviewType === WEBVIEW_TYPE.WELLO_APP
  };
}